
















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import List from '@/components/list.vue'
import Tab from '@/components/tab.vue'
import TaskFilterTab from '@/components/TaskFilterTab.vue'
import { list, getOwner } from '@/api/task/common'
import { PAGINATION_PARAM, partakeList, crowdTypeList, expRequireList, sortList, myAuthList, collectTypes } from '@/global/constants'
import { goTop, isLogin } from '../../global/utils'

@Component({
  components: {
    List,
    Tab,
    TaskFilterTab
  }
})
export default class Task extends Vue {
  private tabsJoinList: object[] = partakeList
  private tabsTypeList: object[] = crowdTypeList
  private tabsSortList: object[] = sortList
  private tabsRepuireList: object[] = expRequireList
  private tabsMyAuthList: object[] = myAuthList
  private dataList: object = []
  private loading: boolean = false
  private total: number = 0
  private dataOwner: object = []
  private collects: object[] = collectTypes
  private collect: string = null
  private params: object = {
    join: null, //是否参与
    is_pass_exp: null,
    type: '3',
    step: null,
    sort: '3',
    q: null,
    from: null,
    ...PAGINATION_PARAM
  }
  private created() {
    this.getOwner()
    this.getList(this.params)
  }

  //获取任务发布人
  private async getOwner() {
    try {
      const data: any = await getOwner()
      this.$nextTick(() => {
        this.dataOwner = data ? data : []
      })
    } catch (err) {
      console.log(err)
    }
  }
  // 获取列表数据
  private async getList(params) {
    this.loading = true
    try {
      const data: any = await list(params)
      this.$nextTick(() => {
        this.dataList = data ? data.rows : []
        this.total = data ? data.total : 0
      })
    } catch (err) {
      console.log(err)
    }
    this.loading = false
    goTop()
  }
  // my_auth 切换
  private changeMyAuth(data) {
    isLogin(this)
    data = data === '2' ? null : data
    this.params = Object.assign(this.params, { have_auth: data, page: 1 })
    this.getList(this.params)
  }
  // join 切换
  private changeJoin(data) {
    isLogin(this)
    data = data === '2' ? null : data
    this.params = Object.assign(this.params, { join: data, page: 1 })
    this.getList(this.params)
  }
  // owner 切换
  private changeOwner(data) {
    data = data === '0' ? null : data
    this.params = Object.assign(this.params, { owner: data, page: 1 })
    this.getList(this.params)
  }
  // is_pass_exp 切换
  private expRequire(data) {
    isLogin(this)
    data = data === '2' ? null : data
    this.params = Object.assign(this.params, { is_pass_exp: data, page: 1 })
    this.getList(this.params)
  }
  // step 切换
  private changeType(data) {
    this.collect = null
    this.params = Object.assign(this.params, {
      step: data === '0' ? null : data,
      page: 1,
      from: null
    })
    this.getList(this.params)
  }
  // sort 切换
  private changeSort(data) {
    data = data === '0' ? null : data
    this.params = Object.assign(this.params, { sort: data, page: 1 })
    this.getList(this.params)
  }
  // 搜索
  private handleSearch(data) {
    let path = `/task/search?q=${data}&type=0`
    window.open(path, '_blank')
    // this.getList(Object.assign(this.params, { page: 1 }));
  }
  // 重置
  private clearSearch() {
    ;(this.params as any).q = null
    this.getList(Object.assign(this.params, { page: 1 }))
  }
  // page切换
  public changePage(data) {
    this.params = Object.assign(this.params, { page: data })
    this.getList(this.params)
  }
  // 选择采集任务
  private onChangeCollect(value) {
    if (!value) return
    this.params = Object.assign(this.params, {
      step: '8',
      from: value === '0' ? null : value,
      page: 1
    })
    ;(this.$refs.typeTab as any).reSet()
    this.getList(this.params)
  }
}
